// api/financeApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Source from '../../Source';

export const financeApi = createApi({
  reducerPath: 'financeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: Source.getAddress(),
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('access');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCashData: builder.query({
      query: ({ date }) => ({
        url: '/api/money',
        params: {
          delete: 'False',
          EndDate: date,
          type: 'cash'
        }
      }),
      providesTags: ['CashData']
    }),
    
    getTransactions: builder.query({
      query: ({ date, type }) => ({
        url: '/api/transactions',
        params: {
          date,
          type
        }
      }),
      providesTags: ['Transactions']
    }),
    
    // سایر endpointها برای CRUD عملیات
    addTransaction: builder.mutation({
      query: (transaction) => ({
        url: '/api/transactions',
        method: 'POST',
        body: transaction
      }),
      invalidatesTags: ['CashData', 'Transactions']
    }),
    
    updateTransaction: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/api/transactions/${id}`,
        method: 'PUT',
        body: patch
      }),
      invalidatesTags: ['CashData', 'Transactions']
    }),
    
    deleteTransaction: builder.mutation({
      query: (id) => ({
        url: `/api/transactions/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['CashData', 'Transactions']
    })
  })
});

export const {
  useGetCashDataQuery,
  useGetTransactionsQuery,
  useAddTransactionMutation,
  useUpdateTransactionMutation,
  useDeleteTransactionMutation
} = financeApi;